export enum UtilityFunction {
  reindexDocuments = 'Reindex Documents',
  reindexLeads = 'Reindex Leads',
  reindexAlgoliaTickets = 'Reindex Algolia Tickets',
  purgeRedisCache = 'Purge Redis Cache',
}
